/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SuitesInputs */

const en_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suites`)
};

const es_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suites`)
};

const fr_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suites`)
};

const de_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suiten`)
};

const ja_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スイート数`)
};

const zh_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套房`)
};

const ar_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أجنحة`)
};

const id_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suite`)
};

const it_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suite`)
};

const ru_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Апартаменты`)
};

const pt_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suítes`)
};

const ko_suites = /** @type {(inputs: SuitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스위트룸 수`)
};

/**
* | output |
* | --- |
* | "Suites" |
*
* @param {SuitesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const suites = /** @type {((inputs?: SuitesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SuitesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_suites(inputs)
	if (locale === "es") return es_suites(inputs)
	if (locale === "fr") return fr_suites(inputs)
	if (locale === "de") return de_suites(inputs)
	if (locale === "ja") return ja_suites(inputs)
	if (locale === "zh") return zh_suites(inputs)
	if (locale === "ar") return ar_suites(inputs)
	if (locale === "id") return id_suites(inputs)
	if (locale === "it") return it_suites(inputs)
	if (locale === "ru") return ru_suites(inputs)
	if (locale === "pt") return pt_suites(inputs)
	return ko_suites(inputs)
});